import { Badge, Button, Image, Pagination, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import './QuickBites.css';
import { ArrowRightOutlined } from '@ant-design/icons'
import useRetail from '../../../hooks/useRetail'
import { useNavigate } from 'react-router-dom'
import useProducts from '../../../hooks/common/useProducts';
import { useData } from '../../../context/DataContext';
import beveragesImage from '../../../../src/assets/images/dining/quickfood/img-aloo-tikki.webp';
// import { useBookingRestrictionStore } from '../../../context/BookingRestrictionContext';

const QuickBites = () => {
    // const { showRestrictionModal } = useBookingRestrictionStore();
    const { getCategoryData } = useRetail();
    const { currentPage, setCurrentPage, setPageSize, pageSize, total, getFoods} = useProducts();
    const [ refreshments, setRefreshments ] = useState([]);
    const navigate = useNavigate();
    const { disabled, tooltipMessage} = useData();

    useEffect(() => {
        const fetchData = async () => {
            const categoryData = await getCategoryData();
            
            if (categoryData) {
                const snacksCategory = categoryData.find(category => category.name.toLowerCase() === 'refreshments');

                const response = await getFoods(snacksCategory?._id);
                if (snacksCategory) {
                    const filteredItems = response.foods.filter(item => item.categoryId === snacksCategory._id);
                    setRefreshments(filteredItems);                   
                }
            }
        };
        fetchData();
    }, [currentPage, pageSize]);

    const handlePageChange = (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const CustomButton = tooltipMessage ? (
        <Tooltip title={tooltipMessage}>
            <span>
            <Button 
                className={`${ window?.innerWidth > 834.98 ? "fs-20" : window?.innerWidth <= 425 ? "fs-16" : "fs-16" } fw-700 booking-btn direct-btn text-black`} 
                size="large"
                disabled={disabled}
                style={{borderColor: '#272727'}}
                onClick={() => {
                    navigate('/booking');
                    // showRestrictionModal(true);
                }}
            >
                <span className='fs-5'><ArrowRightOutlined/></span>
                Get Foods
            </Button>
            </span>
        </Tooltip>
    ) : (
        <Button 
            className={`${ window?.innerWidth > 834.98 ? "fs-20" : window?.innerWidth <= 425 ? "fs-16" : "fs-16" } fw-700 booking-btn direct-btn`} 
            size="large"
            style={{borderColor: '#272727'}}
            onClick={() => {
                navigate('/booking');
                // showRestrictionModal(true);
            }}
        >
            <span className='fs-5'><ArrowRightOutlined/></span>
            Get Foods
        </Button>
    );

    return (
        <Container className='py-5'>
            <Row className="d-flex align-items-center justify-content-center">
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='text-center'>
                
                    <div className="quickfood"></div>

                    <Row className="d-flex align-items-center justify-content-between pt-5">
                        <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12} className="food-content text-start">
                            <Badge 
                                color="#006836" 
                                text="SNACKS, BEVERAGES AND ICE CREAM"
                                className={`${ window?.innerWidth > 834.98 ? "fs-20" : window?.innerWidth <= 425 ? "fs-14" : "fs-20" } fw-600 badge-custom1 mx-1`}
                            />
                            <h2 className={`${ window?.innerWidth > 834.98 ? "fs-28" : window?.innerWidth <= 425 ? "fs-20" : "fs-24" } fw-700 pt-2`}>
                                Quick Refreshments, Sweet Treats
                            </h2>
                            <p className={`${ window?.innerWidth > 834.98 ? "fs-20" : window?.innerWidth <= 425 ? "fs-16" : "fs-18" } fw-400`}>
                                Recharge with zesty snacks, refreshing drinks, and creamy ice creams. 
                                Perfect for a mid-adventure energy boost or a delightful dessert to end your meal.
                            </p>
                        </Col>
                    
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12} className="direction-btn text-end">
                            <div>
                                {CustomButton}
                                <p className={`${ window?.innerWidth > 834.98 ? "fs-20" : window?.innerWidth <= 425 ? "fs-16" : "fs-18" } fw-400 food-content pt-3`}>Dining only available at the park</p>
                            </div>
                        </Col>
                    </Row>

                    <div className='d-flex justify-content-end align-items-center mb-4'>
                        <Pagination
                            current={currentPage}
                            pageSize={pageSize}
                            total={total}
                            onChange={handlePageChange}
                            size="large"
                        />
                    </div>

                    <Row>
                        {refreshments.map((item, index) => (
                            <Col key={index} xxl={3} xl={3} lg={3} md={4} sm={12} xs={12} className="mb-4">
                                <div className="text-center">
                                    <Image
                                        src={item.mediaId?.key || beveragesImage}
                                        alt={item.name || 'No Image'}
                                        preview={false}
                                        style={{ borderRadius: '24px' }}
                                    />
                                    <div className="d-flex justify-content-between align-items-center pt-3">
                                        <h4 
                                            className={`${ window?.innerWidth > 834.98 ? "fs-24" : window?.innerWidth <= 425 ? "fs-22" : "fs-22" } fw-700 text-start mb-0`} 
                                            style={{textAlign: 'left'}}
                                        >
                                            {item.name}
                                        </h4>
                                        <div className="d-flex align-items-center">
                                            <span className="ms-2 fs-20 text-success">★</span>
                                            <span className="fw-400 fs-20 ms-1 text-success">4.5</span>                                           
                                            {/* <p className="fw-400 fs-20 mb-0 ms-2">({item.reviews})</p> */}
                                        </div>
                                    </div>

                                    <p className={`${window?.innerWidth > 834.98 ? "fs-18" : window?.innerWidth <= 425 ? "fs-14" : "fs-16"} fw-400 text-start`}>
                                        {item.desc.replace(/<\/?p>/g, "").replace(/<[^>]+>/g, "")}
                                    </p>

                                    <p 
                                        className={`${ window?.innerWidth > 834.98 ? "fs-20" : window?.innerWidth <= 425 ? "fs-18" : "fs-20" } fw-400 text-start`}
                                    >
                                        ₹{item.price.toFixed(2)}
                                    </p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}

export default QuickBites
